export const ARTICLE_JSON_LD_ID = 'article-json-ld';

export const KATEX_VERSION = '0.16.9';
export const KATEX_CSS_ID = 'katex-css';
export const KATEX_JS_ID = 'katex-js';
export const KATEX_AUTORENDER_ID = 'katex-auto-render';
export const KATEX_CSS_URL = `https://cdn.jsdelivr.net/npm/katex@${KATEX_VERSION}/dist/katex.min.css`;
export const KATEX_JS_URL = `https://cdn.jsdelivr.net/npm/katex@${KATEX_VERSION}/dist/katex.min.js`;
export const KATEX_AUTORENDER_URL = `https://cdn.jsdelivr.net/npm/katex@${KATEX_VERSION}/dist/contrib/auto-render.min.js`;
